import { Chess } from "chess.js";

import { replayUciMove } from "@/shared/ui/chessMove";

export function formatStockfishPvSan(fen: string, pv: string[]) {
  if (pv.length === 0) {
    return "...";
  }

  try {
    const board = new Chess(fen);
    const sanMoves: string[] = [];
    for (const uci of pv.slice(0, 12)) {
      const move = replayUciMove(board, uci);
      sanMoves.push(move?.san ?? uci);
    }
    return sanMoves.join(" ");
  } catch {
    return pv.slice(0, 12).join(" ");
  }
}
